(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["blog-category-rows"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', (event) => {
    const tab = event.target.closest('[data-blog-category-tab]');

    if (tab) {
      const section = tab.closest('.blog-category-rows');
      const panelId = tab.dataset.blogCategoryTab;

      section.querySelectorAll('[data-blog-category-tab]').forEach((button) => {
        const active = button === tab;
        button.classList.toggle('is-active', active);
        button.setAttribute('aria-selected', active ? 'true' : 'false');
      });

      section.querySelectorAll('[data-blog-category-panel]').forEach((panel) => {
        panel.classList.toggle('is-active', panel.dataset.blogCategoryPanel === panelId);
      });
      return;
    }

    const button = event.target.closest('[data-blog-category-prev], [data-blog-category-next]');

    if (!button) return;

    const viewport = button.closest('[data-blog-category-carousel]');
    const row = viewport?.querySelector('.blog-category-rows__grid');
    const card = row?.querySelector('.blog-category-rows__card');

    if (!row || !card) return;

    const direction = button.matches('[data-blog-category-prev]') ? -1 : 1;
    const gap = parseFloat(getComputedStyle(row).columnGap || '0');
    row.scrollBy({ left: direction * (card.getBoundingClientRect().width + gap), behavior: 'smooth' });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["country-travel-profile"] && !Shopify.designMode) return;
  try {
    
  (() => {
    document.querySelectorAll('[data-season-planner]').forEach((planner) => {
      const tabs = Array.from(planner.querySelectorAll('[data-season-tab]'));
      const panels = Array.from(planner.querySelectorAll('[data-season-panel]'));

      const activateTab = (nextTab, moveFocus = false) => {
        tabs.forEach((tab) => {
          const isActive = tab === nextTab;
          tab.classList.toggle('is-active', isActive);
          tab.setAttribute('aria-selected', String(isActive));
          tab.tabIndex = isActive ? 0 : -1;
        });
        panels.forEach((panel) => {
          panel.hidden = panel.id !== nextTab.getAttribute('aria-controls');
        });
        if (moveFocus) nextTab.focus();
      };

      tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => activateTab(tab));
        tab.addEventListener('keydown', (event) => {
          let nextIndex = index;
          if (event.key === 'ArrowRight' || event.key === 'ArrowDown') nextIndex = (index + 1) % tabs.length;
          if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') nextIndex = (index - 1 + tabs.length) % tabs.length;
          if (event.key === 'Home') nextIndex = 0;
          if (event.key === 'End') nextIndex = tabs.length - 1;
          if (nextIndex === index) return;
          event.preventDefault();
          activateTab(tabs[nextIndex], true);
        });
      });
    });

    const containers = document.querySelectorAll('[data-weather-enabled="true"]');

    const escapeHtml = (value) => String(value ?? '')
      .replaceAll('&', '&amp;')
      .replaceAll('<', '&lt;')
      .replaceAll('>', '&gt;')
      .replaceAll('"', '&quot;')
      .replaceAll("'", '&#039;');

    const validWeatherPayload = (data) => {
      const phases = ['day', 'twilight', 'night'];
      return Boolean(
        data
        && data.current
        && data.local_time
        && phases.includes(data.daylight_phase)
        && Array.isArray(data.daily)
      );
    };

    const destinationLocalTime = (data) => {
      if (data.local_time) return String(data.local_time);

      const observedAt = Date.parse(data.observed_at || '');
      const timezoneOffset = Number(data.timezone_offset);

      if (!Number.isFinite(observedAt) || !Number.isFinite(timezoneOffset)) return '';

      return new Intl.DateTimeFormat('en-CA', {
        hour: 'numeric',
        minute: '2-digit',
        timeZone: 'UTC'
      }).format(new Date(observedAt + timezoneOffset * 1000));
    };

    const weatherIcon = (iconCode, isDay = true) => {
      const code = String(iconCode || (isDay ? '01d' : '01n')).slice(0, 2);
      const nightClass = isDay ? '' : ' country-profile__weather-icon--night';
      const open = `<svg class="country-profile__weather-icon${nightClass}" viewBox="0 0 64 64" aria-hidden="true" focusable="false">`;
      const close = '</svg>';
      const sun = '<circle cx="27" cy="27" r="9" fill="none" stroke="currentColor" stroke-width="3"/><path d="M27 7v7M27 40v7M7 27h7M40 27h7M13 13l5 5M36 36l5 5M41 13l-5 5M18 36l-5 5" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round"/>';
      const moon = '<path d="M39 42A18 18 0 0 1 24 14a17 17 0 1 0 15 28Z" fill="none" stroke="currentColor" stroke-width="3" stroke-linejoin="round"/>';
      const cloud = '<path class="weather-cloud" d="M19 47h27a10 10 0 0 0 1-20 15 15 0 0 0-28-4 12 12 0 0 0 0 24Z" stroke-width="3" stroke-linejoin="round"/>';
      const smallCloud = '<path class="weather-cloud" d="M25 48h23a9 9 0 0 0 0-18 13 13 0 0 0-24-3 11 11 0 0 0 1 21Z" stroke-width="3" stroke-linejoin="round"/>';
      const rain = '<path class="weather-water" d="M25 51l-3 6M36 51l-3 6M47 51l-3 6" fill="none" stroke-width="3" stroke-linecap="round"/>';
      const snow = '<path class="weather-water" d="M24 51v8M20 55h8M37 51v8M33 55h8M50 51v8M46 55h8" fill="none" stroke-width="2.5" stroke-linecap="round"/>';

      if (code === '01') return `${open}${isDay ? sun : moon}${close}`;
      if (code === '02') return `${open}${isDay ? sun : moon}${smallCloud}${close}`;
      if (code === '03' || code === '04') return `${open}${cloud}${close}`;
      if (code === '09' || code === '10') return `${open}${cloud}${rain}${close}`;
      if (code === '11') return `${open}${cloud}<path class="weather-lightning" d="M34 48h9l-7 12 1-8h-7Z" stroke-width="1.5" stroke-linejoin="round"/>${close}`;
      if (code === '13') return `${open}${cloud}${snow}${close}`;
      if (code === '50') return `${open}<path d="M11 23h42M7 33h38M15 43h42" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round"/>${close}`;
      return `${open}${isDay ? sun : moon}${close}`;
    };

    const renderWeather = (container, data, unit) => {
      const symbol = unit === 'fahrenheit' ? '°F' : '°C';
      const speedUnit = unit === 'fahrenheit' ? 'mph' : 'm/s';
      const current = data.current || {};
      const forecast = Array.isArray(data.daily) ? data.daily.slice(0, 5) : [];
      const forecastMarkup = forecast.map((day) => `
        <article>
          <time datetime="${escapeHtml(day.date)}">${escapeHtml(day.label || day.date)}</time>
          ${weatherIcon(day.icon, !String(day.icon || '').endsWith('n'))}
          <strong>${escapeHtml(Math.round(day.temp_max))}° / ${escapeHtml(Math.round(day.temp_min))}°</strong>
          <span>${escapeHtml(day.description)}</span>
        </article>
      `).join('');
      const isDay = data.is_day !== false;
      const supportedPhases = ['day', 'twilight', 'night'];
      const phase = supportedPhases.includes(data.daylight_phase) ? data.daylight_phase : (isDay ? 'day' : 'night');
      const isIconDay = !String(current.icon || (isDay ? '01d' : '01n')).endsWith('n');
      const twilightLabel = data.twilight_type === 'sunset' ? 'Sunset' : 'Sunrise';
      const daylightLabel = phase === 'twilight' ? twilightLabel : (phase === 'day' ? 'Daytime' : 'Nighttime');
      const localTime = destinationLocalTime(data);
      const localTimeLabel = localTime ? `${escapeHtml(localTime)} local time` : 'Local time unavailable';
      const stateClass = phase === 'night'
        ? ' country-profile__day-state--night'
        : (phase === 'twilight' ? ' country-profile__day-state--twilight' : '');

      container.innerHTML = `
        <div class="country-profile__weather-current country-profile__weather-current--${phase}">
          <div class="country-profile__weather-summary">
            ${weatherIcon(current.icon, isIconDay)}
            <div>
              <p class="country-profile__weather-temperature">${escapeHtml(Math.round(current.temperature))}${symbol}</p>
              <p class="country-profile__weather-description">${escapeHtml(current.description)}</p>
              <small class="country-profile__weather-place">${escapeHtml(data.location || container.dataset.location)}</small>
            </div>
          </div>
          <div class="country-profile__weather-visual">
            <small class="country-profile__weather-local-time">${localTimeLabel}</small>
            <span class="country-profile__day-state${stateClass}">${daylightLabel}</span>
          </div>
        </div>
        <dl class="country-profile__weather-meta">
          <div><dt>Feels like</dt><dd>${escapeHtml(Math.round(current.feels_like))}${symbol}</dd></div>
          <div><dt>Humidity</dt><dd>${escapeHtml(current.humidity)}%</dd></div>
          <div><dt>Wind</dt><dd>${escapeHtml(current.wind_speed)} ${speedUnit}</dd></div>
          ${data.sunrise ? `<div><dt>Sunrise</dt><dd>${escapeHtml(data.sunrise)}</dd></div>` : ''}
          ${data.sunset ? `<div><dt>Sunset</dt><dd>${escapeHtml(data.sunset)}</dd></div>` : ''}
        </dl>
        ${forecastMarkup ? `<div class="country-profile__forecast">${forecastMarkup}</div>` : ''}
        <p class="country-profile__weather-attribution">Weather data provided by OpenWeather. Updated ${escapeHtml(data.updated_label || 'recently')}.</p>
      `;
    };

    containers.forEach(async (container) => {
      const endpoint = container.dataset.weatherEndpoint;
      const latitude = container.dataset.latitude;
      const longitude = container.dataset.longitude;
      const unit = container.dataset.temperatureUnit === 'fahrenheit' ? 'fahrenheit' : 'celsius';
      const status = container.querySelector('.country-profile__weather-status');

      if (!endpoint || !latitude || !longitude) {
        if (status) status.textContent = 'Live forecast is temporarily unavailable.';
        return;
      }

      const cacheKey = `travelfi-weather:v4:${latitude}:${longitude}:${unit}`;
      const maxAge = 60 * 60 * 1000;

      try {
        const cached = JSON.parse(localStorage.getItem(cacheKey));
        if (cached && Date.now() - cached.savedAt < maxAge && validWeatherPayload(cached.data)) {
          renderWeather(container, cached.data, unit);
          return;
        }
        localStorage.removeItem(cacheKey);
      } catch (_) {
      }

      try {
        const url = new URL(endpoint, window.location.origin);
        url.searchParams.set('lat', latitude);
        url.searchParams.set('lon', longitude);
        url.searchParams.set('units', unit === 'fahrenheit' ? 'imperial' : 'metric');
        url.searchParams.set('location', container.dataset.location || '');
        url.searchParams.set('contract', '4');

        const response = await fetch(url, {
          cache: 'no-store',
          headers: { Accept: 'application/json' }
        });
        if (!response.ok) throw new Error(`Weather request failed: ${response.status}`);

        const data = await response.json();
        if (!validWeatherPayload(data)) throw new Error('Weather response contract is outdated.');
        renderWeather(container, data, unit);
        localStorage.setItem(cacheKey, JSON.stringify({ savedAt: Date.now(), data }));
      } catch (_) {
        if (status) status.textContent = 'Live forecast is temporarily unavailable.';
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["data-usage-calculator"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('data-usage-calculator')) {
    customElements.define('data-usage-calculator', class extends HTMLElement {
      connectedCallback() {
        this.form = this.querySelector('[data-calculator-form]');
        if (!this.form) return;

        this.locale = document.documentElement.lang || 'en';
        this.bufferPercent = Number(this.dataset.bufferPercent || 0);
        this.daysRange = this.querySelector('[data-days-range]');
        this.daysNumber = this.querySelector('[data-days-number]');
        this.customUsage = this.querySelector('[data-custom-gb]');
        this.cloudUsage = this.querySelector('[data-cloud-gb]');
        this.dialog = this.querySelector('dialog');

        this.addEventListener('input', (event) => this.handleInput(event));
        this.addEventListener('click', (event) => this.handleClick(event));
        this.form.addEventListener('reset', () => requestAnimationFrame(() => this.calculate()));
        this.dialog?.addEventListener('click', (event) => {
          if (event.target === this.dialog) this.dialog.close();
        });

        this.calculate();
      }

      clamp(input) {
        const min = Number(input.min || 0);
        const max = Number(input.max || Number.MAX_SAFE_INTEGER);
        const value = Number(input.value || 0);
        input.value = Math.min(max, Math.max(min, value));
        return Number(input.value);
      }

      handleInput(event) {
        const target = event.target;

        if (target.matches('[data-days-range]')) this.daysNumber.value = target.value;
        if (target.matches('[data-days-number]')) this.daysRange.value = this.clamp(target);

        const activity = target.closest('[data-activity]');
        if (activity) {
          const range = activity.querySelector('[data-activity-range]');
          const number = activity.querySelector('[data-activity-number]');
          if (target === range) number.value = range.value;
          if (target === number) range.value = this.clamp(number);
        }

        if (target === this.customUsage) this.clamp(target);
        this.calculate();
      }

      handleClick(event) {
        if (event.target.closest('[data-calculator-open]')) this.dialog?.showModal();
        if (event.target.closest('[data-calculator-close]')) this.dialog?.close();
      }

      format(value, maximumFractionDigits = 2) {
        return new Intl.NumberFormat(this.locale, {
          minimumFractionDigits: value > 0 && value < 1 ? 2 : 0,
          maximumFractionDigits
        }).format(value);
      }

      calculate() {
        const days = this.clamp(this.daysNumber);
        this.daysRange.value = days;

        let dailyMb = 0;
        this.querySelectorAll('[data-activity]').forEach((activity) => {
          const minutes = this.clamp(activity.querySelector('[data-activity-number]'));
          activity.querySelector('[data-activity-range]').value = minutes;
          dailyMb += minutes * Number(activity.dataset.rateMb || 0);
        });

        dailyMb += this.clamp(this.customUsage) * 1000;
        dailyMb += Number(this.cloudUsage?.value || 0) * 1000;
        const dailyGb = dailyMb / 1000;
        const rawTotalGb = dailyGb * days;
        const bufferedTotalGb = rawTotalGb * (1 + this.bufferPercent / 100);
        const minimumTotalGb = bufferedTotalGb > 0 ? Math.ceil(bufferedTotalGb * 2) / 2 : 0;
        const minimumDailyHighSpeedGb = days > 0 ? minimumTotalGb / days : 0;

        this.querySelector('[data-total-gb]').textContent = this.format(minimumTotalGb, 1);
        this.querySelector('[data-result-days]').textContent = this.format(days, 0);
        this.querySelector('[data-daily-gb]').textContent = this.format(dailyGb);
        this.querySelector('[data-raw-total-gb]').textContent = this.format(rawTotalGb);
        this.querySelector('[data-daily-quota-gb]').textContent = this.format(minimumDailyHighSpeedGb);

        this.querySelector('[data-output-days]').value = days;
        this.querySelector('[data-output-total]').value = minimumTotalGb;
        this.querySelector('[data-output-daily]').value = minimumDailyHighSpeedGb.toFixed(4);

        this.dataset.minimumDays = days;
        this.dataset.minimumTotalGb = minimumTotalGb;
        this.dataset.minimumDailyHighSpeedGb = minimumDailyHighSpeedGb.toFixed(4);

        this.dispatchEvent(new CustomEvent('data-usage:calculated', {
          bubbles: true,
          detail: {
            minimumDays: days,
            minimumTotalGb,
            minimumDailyHighSpeedGb,
            estimatedDailyGb: dailyGb,
            estimatedTotalGb: rawTotalGb
          }
        }));
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["esim-installation-guide"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const validDevices = ['iphone', 'samsung', 'pixel', 'xiaomi', 'motorola', 'oppo', 'huawei', 'other'];

    const initializeGuide = (root) => {
      if (root.dataset.esimGuideReady === 'true') return;
      root.dataset.esimGuideReady = 'true';

      const tabs = Array.from(root.querySelectorAll('[role="tab"][data-device]'));
      const panels = Array.from(root.querySelectorAll('[data-device-panel]'));

      const activate = (device, updateHash = false, moveFocus = false) => {
        const selectedDevice = validDevices.includes(device) ? device : 'iphone';

        tabs.forEach((tab) => {
          const isActive = tab.dataset.device === selectedDevice;
          tab.setAttribute('aria-selected', String(isActive));
          tab.tabIndex = isActive ? 0 : -1;
          if (isActive && moveFocus) tab.focus();
          if (isActive && (moveFocus || selectedDevice !== 'iphone')) tab.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'auto' });
        });

        panels.forEach((panel) => {
          panel.hidden = panel.dataset.devicePanel !== selectedDevice;
        });

        if (updateHash) {
          const nextUrl = `${window.location.pathname}${window.location.search}#${selectedDevice}`;
          window.history.replaceState(null, '', nextUrl);
        }
      };

      tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => activate(tab.dataset.device, true));
        tab.addEventListener('keydown', (event) => {
          let nextIndex = index;
          if (event.key === 'ArrowRight') nextIndex = (index + 1) % tabs.length;
          if (event.key === 'ArrowLeft') nextIndex = (index - 1 + tabs.length) % tabs.length;
          if (event.key === 'Home') nextIndex = 0;
          if (event.key === 'End') nextIndex = tabs.length - 1;
          if (nextIndex === index && !['Home', 'End'].includes(event.key)) return;
          event.preventDefault();
          activate(tabs[nextIndex].dataset.device, true, true);
        });
      });

      const applyHash = () => activate(window.location.hash.slice(1), false);
      applyHash();
      window.addEventListener('hashchange', () => {
        const hash = window.location.hash.slice(1);
        if (validDevices.includes(hash)) activate(hash, false);
      });
    };

    document.querySelectorAll('[data-esim-guide]').forEach(initializeGuide);
    document.addEventListener('shopify:section:load', (event) => {
      event.target.querySelectorAll('[data-esim-guide]').forEach(initializeGuide);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq-page"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const sections = document.querySelectorAll('[data-faq-page]');

    sections.forEach((section) => {
      const search = section.querySelector('[data-faq-search]');
      const content = section.querySelector('[data-faq-content]');
      const rows = [...section.querySelectorAll('.details')];
      const groups = [...section.querySelectorAll('.faq-page__content > .group-block')];
      const empty = section.querySelector('[data-faq-empty]');
      const count = section.querySelector('[data-faq-count]');
      const filters = [...section.querySelectorAll('[data-faq-filter]')];
      let activeFilter = '';

      if (count) count.textContent = rows.length;

      const applyFilter = () => {
        const query = search ? search.value.trim().toLowerCase() : '';
        let visibleRows = 0;

        rows.forEach((row) => {
          const text = row.textContent.toLowerCase();
          const matchesQuery = !query || text.includes(query);
          const group = row.closest('.group-block');
          const groupText = group ? group.textContent.toLowerCase() : '';
          const matchesFilter = !activeFilter || groupText.includes(activeFilter.toLowerCase());
          const shouldShow = matchesQuery && matchesFilter;

          row.hidden = !shouldShow;
          if (shouldShow) visibleRows += 1;
        });

        groups.forEach((group) => {
          const groupRows = [...group.querySelectorAll('.details')];
          group.hidden = groupRows.length > 0 && groupRows.every((row) => row.hidden);
        });

        if (empty) empty.hidden = visibleRows > 0;
      };

      search?.addEventListener('input', applyFilter);

      filters.forEach((filter) => {
        filter.addEventListener('click', (event) => {
          event.preventDefault();
          activeFilter = filter.dataset.faqFilter || '';
          filters.forEach((item) => item.classList.toggle('is-active', item === filter));
          content?.scrollIntoView({ behavior: 'smooth', block: 'start' });
          applyFilter();
        });
      });

      applyFilter();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["power-adapter-guide"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('power-adapter-guide')) {
    customElements.define('power-adapter-guide', class extends HTMLElement {
      connectedCallback() {
        try {
          this.destinations = JSON.parse(this.querySelector('[data-destination-data]').textContent).map(item => ({
            ...item,
            id: String(item.id),
            plugs: (item.plugs || []).map(plug => ({
              ...plug,
              code: String(plug.code || '')
            }))
          }));
        } catch (error) {
          this.destinations = [];
        }

        this.originSelect = this.querySelector('[data-origin]');
        this.destinationSelect = this.querySelector('[data-destination]');
        this.originOptions = this.querySelector('[data-origin-options]');
        this.destinationOptions = this.querySelector('[data-destination-options]');
        this.answer = this.querySelector('[data-answer]');
        this.cards = this.querySelector('[data-cards]');
        this.chips = this.querySelector('[data-chips]');
        this.empty = this.querySelector('[data-empty]');

        this.origin = '';
        this.selected = [];

        this.populate();
        this.addEventListener('click', event => this.handleClick(event));
        this.originSelect.addEventListener('change', event => {
          const origin = this.findByName(event.target.value);
          this.origin = origin?.id || '';
          event.target.value = origin?.name || '';
          this.selected = this.selected.filter(id => id !== this.origin);
          this.updateDestinationOptions();
          this.render();
        });
        this.render();
      }
      populate() {
        this.originOptions.innerHTML = this.destinations.map(item => `<option value="${item.name}"></option>`).join('');
        this.originSelect.value = '';
        this.updateDestinationOptions();
      }
      updateDestinationOptions() {
        const available = this.destinations.filter(item => item.id !== this.origin && !this.selected.includes(item.id));
        this.destinationOptions.innerHTML = available.map(item => `<option value="${item.name}"></option>`).join('');
        this.destinationSelect.value = '';
      }
      handleClick(event) {
        const add = event.target.closest('[data-add]');
        const remove = event.target.closest('[data-remove]');

        if (add) {
          const destination = this.findByName(this.destinationSelect.value);
          const destinationId = destination?.id || '';
          if (!this.origin || !destinationId || destinationId === this.origin || this.selected.includes(destinationId)) {
            return;
          }
          this.selected.push(destinationId);
          this.updateDestinationOptions();
          this.render();
        }

        if (remove) {
          const removeId = String(remove.dataset.remove || '');
          this.selected = this.selected.filter(id => id !== removeId);
          this.updateDestinationOptions();
          this.render();
        }
      }
      item(id) { return this.destinations.find(destination => destination.id === id); }
      findByName(name) { const normalized = String(name || '').trim().toLocaleLowerCase(); return this.destinations.find(destination => destination.name.toLocaleLowerCase() === normalized); }
      withUnit(value, unit) { const text = String(value || '').trim(); if (!text) return 'Not available'; return new RegExp(`\\b${unit}\\b`, 'i').test(text) ? text : `${text} ${unit}`; }
      render() {
        const origin = this.item(this.origin);
        const selected = this.selected.map(id => this.item(id)).filter(Boolean);
        const requiredByCode = new Map();

        selected.forEach(item => {
          (item.plugs || []).forEach(plug => {
            const code = String(plug.code || '').trim();
            if (!code || requiredByCode.has(code)) {
              return;
            }
            requiredByCode.set(code, {
              code,
              name: plug.name || `Type ${code}`,
              image: plug.image || null,
              illustration: plug.illustration || ''
            });
          });
        });

        const requiredPlugs = [...requiredByCode.values()];
        const compatible = selected.length > 0 && !!origin && selected.every(item =>
          (item.plugs || []).some(plug => (origin.plugs || []).some(originPlug => originPlug.code === plug.code))
        );
        const voltageChange = !!origin && selected.some(item =>
          Number(item.voltage) && Number(origin.voltage) && Math.abs(Number(item.voltage) - Number(origin.voltage)) >= 100
        );

        this.chips.innerHTML = selected.map(item =>
          `<button type="button" class="power-guide__chip" data-remove="${item.id}">${item.flag ? `<img src="${item.flag}" alt="">` : ''}${item.name} <span aria-hidden="true">×</span></button>`
        ).join('');

        if (!origin) {
          this.answer.className = 'power-guide__answer';
          this.answer.innerHTML = '<h2>Select your origin</h2><p>Choose where you are travelling from, then add one or more destinations.</p>';
          this.cards.innerHTML = '';
          this.empty.hidden = selected.length > 0;
          return;
        }

        this.answer.className = `power-guide__answer${compatible ? '' : ' power-guide__answer--warning'}`;
        this.answer.innerHTML = `<h2>${compatible ? 'Your plugs are compatible' : 'Travel adapter recommended'}</h2><p>${selected.length ? (compatible ? `${origin.name || 'Your home country'} plug types are compatible with at least one socket type at every stop.` : `Your ${origin.name || 'home'} plug types are not directly compatible with every socket type on this itinerary.`) : 'Choose one or more destinations to see what you need.'}</p>${requiredPlugs.length ? `<div class="power-guide__plug-list" aria-label="Required plug types">${requiredPlugs.map(plug => `<span class="power-guide__plug-pill">Type ${plug.code}</span>`).join('')}</div>` : ''}${requiredPlugs.length ? `<div class="power-guide__plug-gallery" aria-label="Required plug images">${requiredPlugs.map(plug => `<div class="power-guide__plug-tile">${plug.image ? `<img src="${plug.image}" alt="Plug ${plug.code}">` : plug.illustration}<span class="power-guide__plug-tile-name">${plug.name || `Type ${plug.code}`}</span></div>`).join('')}</div>` : ''}${selected.length > 1 ? `<p style="margin-top:14px">A universal travel adapter is usually the simplest option for this multi-country trip.</p>` : ''}${voltageChange ? `<p style="margin-top:14px"><strong>Voltage note:</strong> destination voltage differs from your origin. Check every device label; a converter may be needed for single-voltage appliances.</p>` : ''}`;
        this.cards.innerHTML = selected.map(item => this.card(item, origin)).join('');
        this.empty.hidden = selected.length > 0;
      }
      card(item, origin) { const match = item.plugs.some(plug => origin?.plugs?.some(originPlug => originPlug.code === plug.code)); return `<article class="power-guide__card"><header>${item.flag ? `<img class="power-guide__card-flag" src="${item.flag}" alt="">` : ''}<h3>${item.name}</h3></header><dl><div><dt>Plug types</dt><dd><div class="power-guide__card-plugs">${item.plugs.map(plug => `<span class="power-guide__card-plug">${plug.image ? `<img src="${plug.image}" alt="Plug ${plug.code}">` : plug.illustration}Type ${plug.code}</span>`).join('')}</div></dd></div><div><dt>Voltage</dt><dd>${this.withUnit(item.voltage, 'V')}</dd></div><div><dt>Frequency</dt><dd>${this.withUnit(item.frequency, 'Hz')}</dd></div></dl><p class="power-guide__status"><strong>${match ? 'Direct plug match' : 'Adapter needed'}</strong>${item.guidance ? ` · ${item.guidance}` : ''}${item.warning ? `<br><strong>Voltage notice:</strong> ${item.warning}` : ''}</p></article>`; }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["topup-portal"] && !Shopify.designMode) return;
  try {
    
  (function() {
    const portals = document.querySelectorAll('.topup-portal');
    if (!portals.length) return;

    portals.forEach((root) => {
      if (root.dataset.topupInit === '1') return;
      root.dataset.topupInit = '1';

    const stateEl = root.querySelector('[data-topup-state]');
    const ordersEl = root.querySelector('[data-topup-orders]');
    const optionsEl = root.querySelector('[data-topup-options]');
    const optionsHeadingEl = root.querySelector('[data-topup-options-heading]');
    const usageEl = root.querySelector('[data-topup-usage]');
    const selectedEl = root.querySelector('[data-topup-selected]');
    const summaryEl = root.querySelector('[data-topup-summary]');
    const contentEl = root.querySelector('[data-topup-content]');
    const ordersMoreEl = root.querySelector('[data-topup-orders-more]');
    const resultsEl = root.querySelector('[data-topup-results]');
    const loadingEl = root.querySelector('[data-topup-loading]');
    const optionsLoadingEl = root.querySelector('[data-topup-options-loading]');
    const appProxyPath = (root.dataset.appProxyPath || '').trim() || '/apps/travelfi-topup';
    const activeCountry = (root.dataset.countryCode || '').trim().toUpperCase();
    const activeCurrency = root.dataset.currencyCode || 'EUR';
    const customerSignedIn = root.dataset.customerSignedIn === 'true';
    const emptyStateMarkup = selectedEl ? selectedEl.innerHTML : '';
    let currentSelectedLine = null;
    let currentPackageSelection = null;
    let topUpController = null;
    let usageController = null;
    let topUpRequestId = 0;

    function escapeHtml(value) {
      return String(value || '')
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#39;');
    }

    function normalizeVariantId(raw) {
      const value = String(raw || '').trim();
      if (!value) return '';
      if (/^\d+$/.test(value)) return value;
      const match = value.match(/(\d+)(?:\D*)$/);
      return match ? match[1] : value;
    }

    function formatDataAllowance(bytes) {
      const gigabyte = 1024 * 1024 * 1024;
      const value = Number(bytes || 0) / gigabyte;
      if (!value) return '';
      return (Number.isInteger(value) ? value : value.toFixed(1)) + ' GB';
    }

    function formatDuration(days, unit) {
      const value = Number(days || 0);
      if (!value) return '';
      return value + ' ' + (value === 1 ? String(unit || 'day').toLowerCase().replace(/s$/, '') : String(unit || 'days').toLowerCase());
    }

    function getVariantDays(variant) {
      const match = String(variant && variant.title || '').match(/(?:\/\s*|\b)(\d+)\s*(?:days?)?\b/i);
      return match ? Number(match[1]) : 0;
    }

    function formatDateTime(value) {
      const date = new Date(value);
      if (!value || Number.isNaN(date.getTime())) return '';
      return new Intl.DateTimeFormat(undefined, {
        day: 'numeric', month: 'short', year: 'numeric', hour: '2-digit', minute: '2-digit'
      }).format(date);
    }

    function formatTopUpPrice(variant) {
      const amount = Number(variant && variant.price);
      if (!Number.isFinite(amount)) return String(variant && variant.price || '');
      const currency = String(variant && variant.currency || activeCurrency);

      try {
        return new Intl.NumberFormat(document.documentElement.lang || undefined, {
          style: 'currency',
          currency,
          currencyDisplay: 'symbol'
        }).format(amount);
      } catch {
        return currency + ' ' + amount.toFixed(2);
      }
    }

    async function beginCartAddNotification(variantId) {
      const { CartLinesUpdateEvent } = await import('@shopify/events');
      const deferred = CartLinesUpdateEvent.createPromise();
      root.dispatchEvent(new CartLinesUpdateEvent({
        action: 'add',
        context: 'topup',
        lines: [{ merchandiseId: variantId, quantity: 1 }],
        promise: deferred.promise
      }));
      return { CartLinesUpdateEvent, deferred };
    }

    function getFlagUrl(countryCode) {
      const normalized = String(countryCode || '').trim().toLowerCase();
      if (!/^[a-z]{2}$/.test(normalized)) return '';
      return 'https://flagcdn.com/w80/' + normalized + '.png';
    }

    function maskIccid(value) {
      const normalized = String(value || '').trim();
      return normalized ? '........' + normalized.slice(-4) : '-';
    }

    function getFlagMarkup(line) {
      const flagUrl = getFlagUrl(line && line.country_code);
      return flagUrl
        ? '<img class="topup-order__flag" src="' + escapeHtml(flagUrl) + '" alt="" loading="lazy">'
        : '<span class="topup-order__flag-fallback" aria-hidden="true">eSIM</span>';
    }

    function getStatusBadge(line, className) {
      const allowedTones = ['ready', 'installing', 'installed', 'active', 'warning', 'depleted', 'unavailable'];
      const requestedTone = String(line && line.status_tone || '').trim().toLowerCase();
      const tone = allowedTones.includes(requestedTone) ? requestedTone : 'unavailable';
      return '<span class="' + className + ' topup-status topup-status--' + tone + '">' +
        escapeHtml(line && line.status || 'Status unavailable') +
      '</span>';
    }

    function setState(text, tone) {
      if (!stateEl) return;
      stateEl.hidden = tone !== 'error';
      stateEl.innerHTML = '<p>' + escapeHtml(text) + '</p>';
      stateEl.style.borderColor = tone === 'error' ? '#f1bcc3' : '#dbe6f7';
      stateEl.style.background = tone === 'error' ? '#fff5f6' : '#ffffff';
    }

    function setLoading(isLoading, isPlanLookup) {
      if (loadingEl) loadingEl.hidden = !isLoading || isPlanLookup;
      if (optionsLoadingEl) optionsLoadingEl.hidden = !isLoading || !isPlanLookup;
      if (optionsEl) optionsEl.hidden = Boolean(isLoading && isPlanLookup);
      if (isPlanLookup && ordersEl) {
        ordersEl.querySelectorAll('[data-sim]').forEach((button) => {
          button.disabled = isLoading || button.dataset.simEligible !== 'true';
        });
      }
    }

    async function fetchTopUpJson(url, options) {
      const transientStatuses = [429, 500, 502, 503, 504];
      for (let attempt = 0; attempt < 2; attempt += 1) {
        const response = await fetch(url, options);
        let payload = null;

        try {
          payload = await response.json();
        } catch {
          if (attempt === 0) {
            await new Promise((resolve) => window.setTimeout(resolve, 1200));
            if (options.signal && options.signal.aborted) {
              throw new DOMException('Request aborted', 'AbortError');
            }
            continue;
          }
          throw new Error('Top-up service is temporarily unavailable. Please try again.');
        }

        if (attempt === 0 && transientStatuses.includes(response.status)) {
          await new Promise((resolve) => window.setTimeout(resolve, 1200));
          if (options.signal && options.signal.aborted) {
            throw new DOMException('Request aborted', 'AbortError');
          }
          continue;
        }

        return { response, payload };
      }

      throw new Error('Top-up service is temporarily unavailable. Please try again.');
    }

    function updateOrdersOverflowIndicator() {
      if (!ordersEl || !ordersMoreEl) return;
      const hasOverflow = ordersEl.scrollHeight > ordersEl.clientHeight + 2;
      const isAtBottom = ordersEl.scrollTop + ordersEl.clientHeight >= ordersEl.scrollHeight - 6;
      ordersMoreEl.hidden = !hasOverflow || isAtBottom;
    }

    function renderUsageLoading() {
      if (!usageEl) return;
      usageEl.innerHTML = '<section class="topup-usage topup-usage--loading" role="status">' +
        '<div class="topup-usage__loading">' +
          '<span>Loading usage for selected eSIM</span>' +
          '<span class="topup-usage__loading-dots" aria-hidden="true">' +
            '<span class="topup-usage__loading-dot"></span>' +
            '<span class="topup-usage__loading-dot"></span>' +
            '<span class="topup-usage__loading-dot"></span>' +
          '</span>' +
        '</div>' +
      '</section>';
    }

    function bringResultsIntoView() {
      if (!resultsEl || !window.matchMedia('(max-width: 900px)').matches) return;
      const behavior = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
      window.requestAnimationFrame(() => {
        resultsEl.scrollIntoView({ behavior, block: 'start' });
      });
    }

    function renderSelectedEsim(line) {
      if (!selectedEl) return;
      if (contentEl) contentEl.classList.toggle('topup-portal__content--empty', !line);
      if (optionsHeadingEl) optionsHeadingEl.hidden = !line;
      if (!line) {
        selectedEl.innerHTML = emptyStateMarkup;
        return;
      }

      selectedEl.innerHTML = '<section class="topup-selected">' +
        '<p class="topup-selected__eyebrow">Selected eSIM</p>' +
        '<div class="topup-selected__body">' +
          getFlagMarkup(line) +
          '<div>' +
            '<p class="topup-selected__title">' + escapeHtml(line.name || line.product_title || 'eSIM') + '</p>' +
            '<p class="topup-selected__meta">' + escapeHtml(line.order_name || '') + ' · ICCID ' + escapeHtml(maskIccid(line.iccid)) + '</p>' +
            '<p class="topup-selected__meta">Purchased: ' + escapeHtml(formatDateTime(line.processed_at) || '-') + '</p>' +
            (line.status_message ? '<p class="topup-selected__status-message">' + escapeHtml(line.status_message) + '</p>' : '') +
          '</div>' +
          getStatusBadge(line, 'topup-selected__status') +
        '</div>' +
      '</section>';
    }

    function renderPurchaseSummary(selectedLine, selection, addHandler) {
      if (!summaryEl) return;
      summaryEl.innerHTML = '<h2>Purchase summary</h2>';

      if (!selectedLine || !selection) {
        summaryEl.innerHTML += '<p class="topup-summary__empty">' +
          (selectedLine ? 'Choose a compatible package to continue.' : 'Select an eSIM and a compatible package to continue.') +
        '</p>';
        return;
      }

      const product = selection.product;
      const variant = selection.variant;
      const allowance = formatDataAllowance(product && product.volume);
      const duration = selection.days > 0
        ? selection.days + ' day' + (selection.days === 1 ? '' : 's')
        : formatDuration(product && product.duration, product && product.duration_unit);
      const packageName = allowance || product.provider_package_name || product.title || variant.title || 'Top-up';
      const price = formatTopUpPrice(variant);

      summaryEl.innerHTML += '<div class="topup-summary">' +
        '<section class="topup-summary__section">' +
          '<p class="topup-summary__label">Top-up</p>' +
          '<p class="topup-summary__value">' + escapeHtml(packageName) + '</p>' +
          '<p class="topup-summary__detail"><span>' + escapeHtml(duration || 'Compatible package') + '</span><span>' + escapeHtml(price) + '</span></p>' +
        '</section>' +
        '<section class="topup-summary__section">' +
          '<p class="topup-summary__label">Target eSIM</p>' +
          '<div class="topup-summary__target">' +
            getFlagMarkup(selectedLine) +
            '<div>' +
              '<p class="topup-summary__value">' + escapeHtml(selectedLine.name || selectedLine.product_title || 'eSIM') + '</p>' +
              '<p class="topup-summary__detail">' + escapeHtml(selectedLine.order_name || '') + '</p>' +
              '<p class="topup-summary__detail">ICCID ' + escapeHtml(maskIccid(selectedLine.iccid)) + '</p>' +
              getStatusBadge(selectedLine, 'topup-summary__status') +
            '</div>' +
          '</div>' +
        '</section>' +
        '<div class="topup-summary__total"><span>Total</span><span class="topup-summary__price">' + escapeHtml(price) + '</span></div>' +
        '<button type="button" class="topup-summary__add" data-topup-summary-add>Add ' + escapeHtml(price) + ' top-up to cart</button>' +
        '<p class="topup-summary__secure">Secure checkout</p>' +
      '</div>';

      const addButton = summaryEl.querySelector('[data-topup-summary-add]');
      if (addButton) {
        addButton.addEventListener('click', () => addHandler(product, variant, selection.days, addButton));
      }
    }

    function renderOrders(orders, topUpLines, selectedSimIdentifier) {
      if (!ordersEl) return;
      if (!Array.isArray(topUpLines) || !topUpLines.length) {
        ordersEl.innerHTML = '<p>No active eSIM lines are available for top-up.</p>';
        updateOrdersOverflowIndicator();
        return;
      }

      ordersEl.innerHTML = '';
      topUpLines.forEach((line) => {
        const isEligible = line.is_active === true;
        const lineButton = document.createElement('button');
        lineButton.type = 'button';
        lineButton.className = 'topup-order__line' + (selectedSimIdentifier === line.iccid ? ' is-selected' : '');
        lineButton.dataset.sim = line.iccid;
        lineButton.dataset.simEligible = isEligible ? 'true' : 'false';
        lineButton.setAttribute('aria-pressed', String(selectedSimIdentifier === line.iccid));
        lineButton.disabled = !isEligible;
        lineButton.innerHTML = getFlagMarkup(line) +
          '<span>' +
            '<p class="topup-order__line-title">' + escapeHtml(line.name || line.product_title || 'eSIM') + '</p>' +
            '<p class="topup-order__line-order">' + escapeHtml(line.order_name || '') + '</p>' +
            '<p class="topup-order__line-meta">ICCID ' + escapeHtml(maskIccid(line.iccid)) + '</p>' +
            '<p class="topup-order__line-meta">Purchased: ' + escapeHtml(formatDateTime(line.processed_at) || '-') + '</p>' +
            getStatusBadge(line, 'topup-order__line-status') +
          '</span>';

        lineButton.addEventListener('click', () => {
          ordersEl.querySelectorAll('[data-sim]').forEach((button) => {
            const isSelected = button === lineButton;
            button.classList.toggle('is-selected', isSelected);
            button.setAttribute('aria-pressed', String(isSelected));
          });
          currentSelectedLine = line;
          currentPackageSelection = null;
          renderSelectedEsim(line);
          renderPurchaseSummary(line, null);
          loadTopups(line.order_name || line.order_id, line.iccid, true);
        });
        ordersEl.appendChild(lineButton);
      });

      window.requestAnimationFrame(updateOrdersOverflowIndicator);
    }

    function renderTopups(options, cartProps, errorMessage, hasSelectedSim) {
      if (!optionsEl) return;
      currentPackageSelection = null;
      renderPurchaseSummary(currentSelectedLine, null);
      if (!hasSelectedSim) {
        optionsEl.innerHTML = '';
        return;
      }
      if (!Array.isArray(options) || !options.length) {
        optionsEl.innerHTML = '<p>' + escapeHtml(errorMessage || 'No compatible top-up products found for this eSIM.') + '</p>';
        return;
      }

      optionsEl.innerHTML = '';
      let hasSelectedPackage = false;
      const selectPackage = (element, selection) => {
        optionsEl.querySelectorAll('[data-topup-package-choice]').forEach((choice) => {
          choice.classList.toggle('is-selected', choice === element);
          if (choice.matches('button')) {
            choice.setAttribute('aria-pressed', String(choice === element));
          }
        });
        hasSelectedPackage = true;
        currentPackageSelection = selection;
        renderPurchaseSummary(currentSelectedLine, selection, addTopUp);
      };

      const addTopUp = async (product, selectedVariant, selectedDays, addBtn) => {
        const variantId = normalizeVariantId(selectedVariant && selectedVariant.id);
        if (!variantId) return;
        const defaultButtonText = addBtn.textContent;
        let cartUpdate = null;
        addBtn.disabled = true;
        addBtn.textContent = 'Adding...';
        try {
          const sectionIds = Array.from(document.querySelectorAll('cart-items-component'))
            .map((component) => component instanceof HTMLElement ? component.dataset.sectionId : '')
            .filter(Boolean);
          const body = {
            id: variantId,
            quantity: 1,
            sections: sectionIds.join(','),
            sections_url: window.location.pathname,
            properties: {
              TopUp: 'Yes',
              TopUpOrder: (cartProps && cartProps.TopUpOrder) || '',
              TopUpSIM: (cartProps && cartProps.TopUpSIM) || '',
              TopUpPackageCode: product.provider_package_code || '',
              _topup_esim_tran_no: (cartProps && cartProps._topup_esim_tran_no) || '',
              _topup_request_id: 'topup_' + Date.now()
            }
          };

          if (product.requires_period_num === true) {
            body.properties.TopUpPeriodNum = String(selectedDays);
          }

          cartUpdate = await beginCartAddNotification(variantId);
          const response = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            credentials: 'same-origin',
            body: JSON.stringify(body)
          });

          if (!response.ok) {
            throw new Error('Add to cart failed (' + response.status + ')');
          }

          const addedItem = await response.json();
          const cartResponse = await fetch('/cart.js', { headers: { 'Accept': 'application/json' }, credentials: 'same-origin' });
          const cart = cartResponse.ok ? await cartResponse.json() : { item_count: addedItem.quantity || 1, items: [addedItem] };
          cartUpdate.deferred.resolve({
            cart: cartUpdate.CartLinesUpdateEvent.createCartFromAjaxResponse(cart),
            detail: {
              didError: false,
              items: Array.isArray(cart && cart.items) ? cart.items : [],
              sections: addedItem.sections || {},
              source: 'topup-portal',
              itemCount: 1
            }
          });
          addBtn.textContent = 'Added to cart';
          setState('Top-up added to cart. Continue to checkout when ready.', 'info');
        } catch (error) {
          cartUpdate?.deferred.reject(error);
          addBtn.disabled = false;
          addBtn.textContent = defaultButtonText;
          setState(error.message || 'Failed to add top-up.', 'error');
        }
      };

      const fixedVariants = options.flatMap((product) => {
        if (product.requires_period_num === true) return [];
        return (Array.isArray(product.variants) ? product.variants : []).map((variant) => ({ product, variant }));
      }).filter((item) => normalizeVariantId(item.variant && item.variant.id));

      if (fixedVariants.length) {
        const fixedSection = document.createElement('section');
        fixedSection.className = 'topup-fixed';
        fixedSection.innerHTML = '<p class="topup-fixed__heading">Choose a compatible package</p><div class="topup-fixed__tiles" data-topup-fixed-tiles></div>';
        const tilesEl = fixedSection.querySelector('[data-topup-fixed-tiles]');
        let selectedFixed = fixedVariants[0];

        const setSelectedFixed = (choice) => {
          selectedFixed = choice;
          const tile = Array.from(tilesEl.querySelectorAll('[data-topup-fixed-variant]')).find((item) => (
            item.dataset.topupFixedVariant === String(choice.variant.id)
          ));
          if (tile) {
            selectPackage(tile, { product: choice.product, variant: choice.variant, days: 0 });
          }
        };

        fixedVariants.forEach((choice) => {
          const packageDetails = [
            formatDataAllowance(choice.product.volume),
            formatDuration(choice.product.duration, choice.product.duration_unit)
          ].filter(Boolean).join(' · ');
          const tile = document.createElement('button');
          tile.type = 'button';
          tile.className = 'topup-fixed__tile';
          tile.dataset.topupFixedVariant = String(choice.variant.id);
          tile.dataset.topupPackageChoice = 'fixed';
          tile.setAttribute('aria-pressed', 'false');
          tile.innerHTML = '' +
            '<span class="topup-fixed__tile-title">' + escapeHtml(choice.product.provider_package_name || choice.product.title || 'Top-up') + '</span>' +
            '<span class="topup-fixed__tile-detail">' + escapeHtml(packageDetails || choice.variant.title || 'Compatible package') + '</span>' +
            '<span class="topup-fixed__tile-price">' + escapeHtml(formatTopUpPrice(choice.variant)) + '</span>';
          tile.addEventListener('click', () => setSelectedFixed(choice));
          tilesEl.appendChild(tile);
        });

        optionsEl.appendChild(fixedSection);
        setSelectedFixed(selectedFixed);
      }

      options.filter((product) => product.requires_period_num === true).forEach((product) => {
        const variants = Array.isArray(product.variants) ? product.variants : [];
        const variant = variants[0];
        const requiresPeriodNum = product.requires_period_num === true;
        const dayVariants = variants
          .map((item) => ({ variant: item, days: getVariantDays(item) }))
          .filter((item) => item.days > 0)
          .sort((left, right) => left.days - right.days);
        let selectedVariant = variant;
        let selectedDays = dayVariants[0] ? dayVariants[0].days : 1;
        const packageDetails = [formatDataAllowance(product.volume), formatDuration(product.duration, product.duration_unit)].filter(Boolean).join(' · ');

        const card = document.createElement('article');
        card.className = 'topup-option' + (requiresPeriodNum ? ' topup-option--unlimited' : '');
        card.dataset.topupPackageChoice = 'unlimited';
        card.setAttribute('role', 'group');
        card.setAttribute('aria-label', product.title || 'Unlimited top-up package');
        card.innerHTML = '' +
          '<div>' +
            '<p class="topup-option__title">' + escapeHtml(product.title || 'Top-up') + '</p>' +
            '<p class="topup-option__variant">' + escapeHtml(packageDetails || (variant && variant.title) || 'Compatible package') + '</p>' +
            '<p class="topup-option__price" data-topup-price>' + escapeHtml(formatTopUpPrice(variant)) + '</p>' +
          '</div>';
        const selectUnlimited = () => {
          selectPackage(card, { product, variant: selectedVariant, days: selectedDays });
        };
        card.addEventListener('click', selectUnlimited);

        let periodInput = null;
        if (requiresPeriodNum) {
          const daysControl = document.createElement('div');
          daysControl.className = 'topup-option__days';
          daysControl.innerHTML = '' +
            '<p class="topup-option__days-label">Choose how many days to add</p>' +
            '<div class="topup-option__days-control">' +
              '<button type="button" class="topup-option__days-step" data-days-decrease aria-label="Decrease days">-</button>' +
              '<div class="topup-option__days-track">' +
                '<input class="topup-option__days-slider" type="range" min="0" max="' + Math.max(0, dayVariants.length - 1) + '" step="1" value="0" data-days-slider aria-label="Number of days to add">' +
                '<span class="topup-option__days-indicator" data-days-indicator>' + selectedDays + '</span>' +
              '</div>' +
              '<button type="button" class="topup-option__days-step" data-days-increase aria-label="Increase days">+</button>' +
            '</div>' +
            '<div class="topup-option__days-scale"><span>' + selectedDays + ' day' + (selectedDays === 1 ? '' : 's') + '</span><span>' + (dayVariants.at(-1)?.days || selectedDays) + ' days</span></div>';
          periodInput = daysControl.querySelector('[data-days-slider]');
          const indicator = daysControl.querySelector('[data-days-indicator]');
          const priceEl = card.querySelector('[data-topup-price]');
          const updatePeriod = () => {
            const index = Math.min(Math.max(0, Number(periodInput.value) || 0), Math.max(0, dayVariants.length - 1));
            const selected = dayVariants[index] || dayVariants[0];
            if (!selected) return;
            selectedVariant = selected.variant;
            selectedDays = selected.days;
            const ratio = dayVariants.length > 1 ? index / (dayVariants.length - 1) : 0;
            periodInput.value = String(index);
            indicator.textContent = String(selectedDays);
            indicator.style.left = (Math.min(0.94, Math.max(0.06, ratio)) * 100) + '%';
            if (priceEl) priceEl.textContent = formatTopUpPrice(selectedVariant);
            if (card.classList.contains('is-selected')) selectUnlimited();
          };
          daysControl.querySelector('[data-days-decrease]').addEventListener('click', () => {
            periodInput.value = String(Math.max(0, Number(periodInput.value) - 1));
            updatePeriod();
          });
          daysControl.querySelector('[data-days-increase]').addEventListener('click', () => {
            periodInput.value = String(Math.min(Math.max(0, dayVariants.length - 1), Number(periodInput.value) + 1));
            updatePeriod();
          });
          periodInput.addEventListener('input', () => {
            updatePeriod();
            selectUnlimited();
          });
          updatePeriod();
          card.appendChild(daysControl);
        }

        optionsEl.appendChild(card);
        if (!hasSelectedPackage && normalizeVariantId(selectedVariant && selectedVariant.id)) {
          selectUnlimited();
        }
      });
    }

    function renderUsage(selectedLine, usage, errorMessage) {
      if (!usageEl) return;
      if (!selectedLine) {
        usageEl.innerHTML = '';
        return;
      }

      const canCheckUsage = Boolean(selectedLine.iccid);
      const totalBytes = Math.max(0, Number(usage && usage.total_bytes) || 0);
      const usedBytes = Math.max(0, Number(usage && usage.used_bytes) || 0);
      const percentage = totalBytes > 0 ? Math.min(100, usedBytes / totalBytes * 100) : 0;
      const displayPercentage = Math.round(percentage);
      const progressWidth = usedBytes > 0 ? Math.max(1, percentage) : 0;
      const isNotActivated = usage && usage.status === 'not_activated';
      const allowanceLabel = usage && usage.allowance_kind === 'daily' ? ' daily allowance' : ' total';
      const usageDetails = usage && totalBytes > 0
        ? [
            (formatDataAllowance(usage.remaining_bytes) || '0 GB') + ' remaining',
            isNotActivated ? 'Not activated yet' : (usage.expires_on ? 'Expires ' + formatDateTime(usage.expires_on) : '')
          ].filter(Boolean).join(' · ')
        : (errorMessage || 'Usage information is not available for this eSIM yet.');
      const progressMarkup = usage && totalBytes > 0
        ? '<div class="topup-usage__progress" role="progressbar" aria-label="Data used" aria-valuemin="0" aria-valuemax="100" aria-valuenow="' + displayPercentage + '">' +
            '<span class="topup-usage__progress-bar" style="width: ' + progressWidth.toFixed(2) + '%"></span>' +
          '</div>' +
          '<div class="topup-usage__scale">' +
            '<span>' + escapeHtml(formatDataAllowance(usedBytes) || '0 GB') + ' used</span>' +
            '<span>' + escapeHtml(formatDataAllowance(totalBytes) || '0 GB') + escapeHtml(allowanceLabel) + ' (' + displayPercentage + '%)</span>' +
          '</div>'
        : '';

      usageEl.innerHTML = '<section class="topup-usage">' +
        '<div class="topup-usage__header">' +
          '<div class="topup-usage__details">' +
            '<p class="topup-usage__title">Current data usage</p>' +
            '<p class="topup-usage__meta">' + escapeHtml(usageDetails) + '</p>' +
          '</div>' +
          '<button type="button" class="topup-usage__button" data-topup-usage-check' + (canCheckUsage ? '' : ' disabled') + '>Check latest usage</button>' +
        '</div>' +
        progressMarkup +
      '</section>';

      const usageButton = usageEl.querySelector('[data-topup-usage-check]');
      if (usageButton) {
        usageButton.addEventListener('click', () => {
          refreshUsage(selectedLine);
        });
      }
    }

    async function refreshUsage(selectedLine) {
      if (!selectedLine || !selectedLine.iccid) return;

      if (usageController) usageController.abort();
      usageController = new AbortController();
      const controller = usageController;
      renderUsageLoading();

      const query = new URLSearchParams({
        order_reference: selectedLine.order_name || selectedLine.order_id || '',
        sim_identifier: selectedLine.iccid,
        include_usage: '1',
        usage_only: '1'
      });

      try {
        const result = await fetchTopUpJson(appProxyPath + '?' + query.toString(), {
          headers: { 'Accept': 'application/json' },
          credentials: 'same-origin',
          cache: 'no-store',
          signal: controller.signal
        });
        const response = result.response;
        const payload = result.payload;
        if (response.status === 401 || payload.status === 'auth_required') {
          throw new Error('Sign in to refresh usage.');
        }
        if (!response.ok || payload.status === 'error') {
          throw new Error(payload.error || payload.details || 'Unable to refresh usage.');
        }
        if (!currentSelectedLine || currentSelectedLine.iccid !== selectedLine.iccid) return;
        renderUsage(payload.selected_line || selectedLine, payload.usage || null, payload.usage_error || '');
      } catch (error) {
        if (error.name === 'AbortError') return;
        if (currentSelectedLine && currentSelectedLine.iccid === selectedLine.iccid) {
          renderUsage(selectedLine, null, error.message || 'Unable to refresh usage.');
        }
      } finally {
        if (usageController === controller) usageController = null;
      }
    }

    async function loadTopups(orderReference, simIdentifier, includeUsage) {
      const isPlanLookup = Boolean(simIdentifier);
      const requestId = ++topUpRequestId;
      if (topUpController) topUpController.abort();
      if (usageController) usageController.abort();
      topUpController = new AbortController();
      const controller = topUpController;
      setState('Loading active orders and top-up options...', 'info');
      if (isPlanLookup && optionsEl) {
        optionsEl.innerHTML = '';
        renderUsageLoading();
        bringResultsIntoView();
      }
      setLoading(true, isPlanLookup);

      const query = new URLSearchParams();

      if (orderReference) {
        query.set('order_reference', orderReference);
      }
      if (simIdentifier) {
        query.set('sim_identifier', simIdentifier);
      }
      if (includeUsage) {
        query.set('include_usage', '1');
      }
      if (activeCountry) {
        query.set('country_code', activeCountry);
      }

      try {
        const queryString = query.toString();
        const requestUrl = appProxyPath + (queryString ? '?' + queryString : '');
        const result = await fetchTopUpJson(requestUrl, {
          headers: { 'Accept': 'application/json' },
          credentials: 'same-origin',
          cache: 'no-store',
          signal: controller.signal
        });
        const response = result.response;
        const payload = result.payload;

        if (response.status === 401 || payload.status === 'auth_required') {
          setState('Sign in to your Shopify customer account to load top-up eligible orders.', 'error');
          return;
        }

        if (!response.ok || payload.status === 'error') {
          throw new Error(payload.error || payload.details || 'Failed to load top-up data.');
        }

        const activeOrders = Array.isArray(payload.active_orders) ? payload.active_orders : payload.orders;
        currentSelectedLine = payload.selected_line || null;
        if (isPlanLookup && !currentSelectedLine && ordersEl) {
          ordersEl.querySelectorAll('[data-sim]').forEach((button) => {
            button.classList.remove('is-selected');
            button.setAttribute('aria-pressed', 'false');
          });
        }
        renderSelectedEsim(currentSelectedLine);
        if (!isPlanLookup) {
          renderOrders(activeOrders || [], payload.top_up_lines || [], payload.selected_line && payload.selected_line.iccid);
        }
        renderUsage(payload.selected_line || null, payload.usage || null, payload.usage_error || '');
        if (requestId !== topUpRequestId) return;
        renderTopups(
          payload.top_up_options || [],
          payload.cart_properties || null,
          payload.top_up_options_error || '',
          Boolean(payload.selected_line && payload.selected_line.iccid)
        );
        setState(payload.next_step || 'Select an eSIM to see compatible top-ups.', 'info');
      } catch (error) {
        if (error.name === 'AbortError') return;
        setState(error.message || 'Unable to load top-ups.', 'error');
        if (isPlanLookup) {
          currentSelectedLine = null;
          currentPackageSelection = null;
          renderSelectedEsim(null);
          renderPurchaseSummary(null, null);
          renderUsage(null, null, '');
          renderTopups([], null, '', false);
        }
      } finally {
        if (requestId === topUpRequestId) {
          topUpController = null;
          setLoading(false, isPlanLookup);
        }
      }
    }

      if (ordersEl) ordersEl.addEventListener('scroll', updateOrdersOverflowIndicator, { passive: true });
      window.addEventListener('resize', updateOrdersOverflowIndicator);

      if (customerSignedIn) {
        loadTopups('');
      }
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
